import { toast } from "react-toastify";
import moment from "moment";

const SelectionMethodMap = {
  "custom 4": "for 2",
  "custom 1": "per adult",
  "per person": "per person",
  "custom 2": "per child",
  "per cabin": "per cabin",
  "custom 5": "per adult (21+)",
  "custom 3": "per adult (21+)", // all adults in cabin
  "custom 6": "1 per 6 guests",
  "custom 7": "1 per 4 guests",
  "custom 8": "per adult (21+)",
};

export const getAllGuestCabins = (allCabinDetails, bookingDetails) => {
  let cabins = bookingDetails.room_with_guest_count.filter((room) => {
    return allCabinDetails
      ?.map((stateroom) => stateroom.category_id)
      .includes(room.category_id);
  });
  cabins = cabins.map((cabin) => {
    return {
      ...cabin,
      ...allCabinDetails.find((item) => item.category_id === cabin.category_id),
    };
  });
  // cabins = [...new Set(cabins.map((item) => item.category_id))].map(
  //   (category_id) => {
  //     return cabins.find((item) => item.category_id === category_id);
  //   }
  // );

  return cabins;
};

export const getSelectionMethod = (Selection_method) => {
  return SelectionMethodMap[Selection_method];
};

export function formatDate(date) {
  const options = { month: "short", day: "2-digit", year: "numeric" };
  return new Date(date).toLocaleDateString("en-US", options);
}

export function addNights(date, nights) {
  const result = new Date(date);
  result.setDate(result.getDate() + nights);
  return result;
}

export const formatUSAmount = (amount) => {
  if (isNaN(amount)) {
    return "";
  }
  amount = +amount;
  let formattedAmount = amount?.toFixed(2);
  let parts = formattedAmount.split(".");
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  return parts.join(".");
};

export const islessthan3days = (bookingDetails) => {
  // bookingDetails.sailing_date = ""MM/DD/YYYY"";
  console.log(bookingDetails);
  const sailingDate = moment(bookingDetails.sailing_date, "MM/DD/YYYY");
  const currentDate = moment();

  // Subtract three days from the sailing date
  const sailingDateMinusThreeDays = sailingDate.subtract(3, "days");

  // Check if the adjusted sailing date is less than or equal to the current date
  if (sailingDateMinusThreeDays.isSameOrBefore(currentDate)) {
    toast.info("Booking modifications restricted within 3 days from sailing.");
    return true;
  }
  return false;
};
